"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SzRadioButton = void 0;
var react_1 = __importDefault(require("react"));
var react_bootstrap_1 = require("react-bootstrap");
var classnames_1 = __importDefault(require("classnames"));
var SzIcon_1 = __importDefault(require("../SzIcon/SzIcon"));
require("./SzRadioButton.scss");
exports.SzRadioButton = function (_a) {
    var choices = _a.choices, className = _a.className, onChange = _a.onChange, name = _a.name, value = _a.value;
    var btnGrpClasses = classnames_1.default('sz-button-group d-flex justify-content-between mb-3', className);
    return (react_1.default.createElement(react_bootstrap_1.ToggleButtonGroup, { name: name, type: "radio", value: value, onChange: onChange, className: btnGrpClasses }, choices &&
        choices.map(function (_a, key) {
            var value = _a.value, icon = _a.icon, label = _a.label;
            var toggleBtnClasses = classnames_1.default('sz-button-group__btn-choose text-secondary text-left d-flex align-items-center p-0 pl-3', { 'justify-content-center': !icon });
            return (react_1.default.createElement(react_bootstrap_1.ToggleButton, { key: key, className: toggleBtnClasses, value: value },
                label,
                icon && (react_1.default.createElement("div", { className: "sz-button-group__btn-choose_icon d-flex align-items-center justify-content-center position-absolute" },
                    react_1.default.createElement(SzIcon_1.default, { variant: "line", icon: icon })))));
        })));
};
exports.default = exports.SzRadioButton;
